import { render, staticRenderFns } from "./PopupMealPlansPair.vue?vue&type=template&id=057a9c22"
import script from "./PopupMealPlansPair.vue?vue&type=script&lang=js"
export * from "./PopupMealPlansPair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports